<template>
  <b-container fluid>
    <b-row class="mb-4">
      <b-col>
        <h3>
          <b-badge variant="primary">
            Contact Details
          </b-badge>
          <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
        </h3>
      </b-col>
      <b-col>
        <b-button 
          block
          @click="$router.go(-1)">
          Back
        </b-button>
      </b-col>
    </b-row>
    <b-table 
      small 
      responsive
      striped
      stacked="sm"
      :busy="waiting"
      :items="items" 
      :fields="fields">
      <div slot="table-busy" class="text-center text-danger">
        <b-spinner class="align-middle"></b-spinner>
        <!-- <strong>Loading...</strong> -->
      </div>
    </b-table>
  </b-container>
</template>

<script>
import { apiService } from '../_services'

export default {
  name: 'ContactDetails',
  data() {
    return {
      waiting: false,
      HHID: '',
      items: [],
      fields: [
        {
          key: 'Name',
          label: 'Name'
        },
        {
          key: 'Gender',
          label: 'Gender'
        },
        {
          key: 'Age',
          label: 'Age'
        },
        {
          key: 'Language',
          label: 'Language'
        },
        {
          key: 'Contact1',
          label: 'Contact1'
        },
        {
          key: 'Contact2',
          label: 'Contact2'
        },
        {
          key: 'Contact3',
          label: 'Contact3'
        },
      ]
    }
  },
  created() {
    this.HHID = this.$route.params.hhid
    let vm = this
    this.waiting = true
    apiService.getContactDetails(this.HHID)
    .then((response) => {
      vm.items = response.data
      vm.waiting = false
    })
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/ContactDetailsPage.vue